import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { RequirePermission } from '@/modules/identity/public';
import { STATUSES, VisitsPage, type VisitsPageFilters } from '@/modules/visits/public';

export const Route = createFileRoute('/_admin/visitas')({
  validateSearch: z.object({
    status: z
      .enum(STATUSES.map((s) => s.value))
      .optional()
      .catch(undefined),
    pagina: z.coerce.number().int().min(1).optional().catch(undefined),
    /** O pedido aberto no painel — dá para mandar o link a um colega. */
    pedido: z.uuid().optional().catch(undefined),
  }),
  component: function VisitsRoute() {
    const { status, pagina, pedido } = Route.useSearch();
    const navigate = Route.useNavigate();
    const onChange = useCallback(
      (next: VisitsPageFilters) =>
        void navigate({
          search: {
            status: next.status,
            pagina: next.page > 1 ? next.page : undefined,
            pedido: next.selected,
          },
          replace: true,
        }),
      [navigate],
    );
    return (
      <RequirePermission anyOf={['visitas.gerenciar']}>
        <VisitsPage filters={{ status, page: pagina ?? 1, selected: pedido }} onChange={onChange} />
      </RequirePermission>
    );
  },
});
